import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useOutletContext } from "react-router";
import { useSelector } from "react-redux";
import axios from "axios";

import { AddressesContainer } from "./styled";

import SectionHeader from "../common/sectionTitle";
import AddressModal from "./addresses/addressModal";

import { FaChevronLeft } from "react-icons/fa6";
import { useRegex } from "../../../../hooks/useRegex";

const Addresses = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const { TelFormat } = useRegex();

  const { url, openModal, closeModal } = useOutletContext();
  const user = useSelector((state) => state?.user?.data[0]);

  const [addressModal, setAddressModal] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [target, setTarget] = useState(null);

  const getAddresses = async () => {
    const url = "/erp/address/get";
    const body = { mberNo: user.mberNo };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        setAddresses(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!user) return;
    getAddresses();
  }, []);

  const toggleModal = (item = null) => {
    setAddressModal((modalState) => !modalState);
    setTarget(item);
  };

  const deleteAddress = async (id) => {
    const url = "/erp/address/delete";
    const body = { id };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        await getAddresses();
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  return (
    <>
      <AddressesContainer>
        <h2>
          {isMobile && (
            <button onClick={() => navigate(`/shop/mypage`)}>
              <FaChevronLeft />
            </button>
          )}
          <span>배송지 관리</span>
        </h2>
        <SectionHeader
          title={`총 ${addresses.length}개`}
          withLine
          action={{
            label: "새 배송지 추가",
            className: "addr",
            clickEvent: () => toggleModal(),
          }}
        />
        <ul className="addresses">
          {addresses.length > 0 ? (
            addresses.map((item, idx) => (
              <li>
                <span>{addresses.length - idx}</span>
                <div>
                  <span>{item.nickname}</span>
                  {item.isDefault && <strong>기본배송지</strong>}
                </div>
                <p>
                  <span>
                    ({item.postcode}) {item.address}
                    {item.detailAddress && ` ${item.detailAddress}`}
                  </span>
                  <span>{TelFormat(item.phone)}</span>
                </p>

                <div>
                  <button onClick={() => toggleModal(item)}>수정</button>
                  <button
                    onClick={() =>
                      openModal({
                        isOpen: true,
                        type: "confirmation",
                        title: `배송지 삭제`,
                        message: [`배송지를 삭제하시겠습니까?`],
                        handleConfirm: () => deleteAddress(item.id),
                        handleCancel: () => closeModal(),
                      })
                    }>
                    삭제
                  </button>
                </div>
              </li>
            ))
          ) : (
            <li>배송지가 존재하지 않습니다.</li>
          )}
        </ul>
        {addressModal && (
          <AddressModal
            openModal={openModal}
            closeModal={closeModal}
            target={target}
            toggleModal={toggleModal}
            getAddresses={getAddresses}
            addresses={addresses}
          />
        )}
      </AddressesContainer>
    </>
  );
};

export default Addresses;
